import { useMutation, useQueryClient } from '@tanstack/react-query';
import { revokeUserTrustedDevices } from '../services/users';
import { userKeys } from './useUsersQuery';
import { handleUserMutationError } from '../services/userErrorHandler';

export const useRevokeTrustedDevicesMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, string>({
        mutationFn: (id) => revokeUserTrustedDevices(id),
        onSuccess: (_, id) => {
            queryClient.invalidateQueries({ queryKey: userKeys.detail(id) });
        },
        onError: (error) => handleUserMutationError(error),
    });
};
